export default __webpack_public_path__ + "static/media/world_map_light.89a21671.png";